<template>
    <div class='post'>
        <router-link :to="{ name: 'blog.post', params: { slug: post.slug } }">
            <figure class="image">
                <img :src="post.images.large" :alt="post.slug">
            </figure>

            <div class="columns is-gapless">
                <div class="column">
                    <div class="title has-background-primary has-text-white">
                        <h2>{{post.title.rendered}}</h2>
                    </div>
                </div>

                <div class="column is-narrow-tablet">
                    <div class="author">
                        <div class="media">
                            <div class="media-left">
                                <figure class="image is-48x48 is-rounded">
                                    <img class="is-rounded" :src="post.author_data.avatar" :alt="post.author_data.name">
                                </figure>
                            </div>

                            <div class="media-content">
                                <p class="title is-6">{{post.author_data.name}}</p>
                                <p class="subtitle is-6 has-text-primary">{{post.author_data.title}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/_variables';
    .post {
        margin-bottom: 2.5rem;
        box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);


        .image {

            img {
                max-height: 300px;
                object-fit: cover;
            }
        }

        .column {
            padding-bottom: 0;
            padding-bottom: 0;
        }

        .title {
            height: 100%;
            display: flex;
            padding: .5rem 1rem;
            h2 {
                display: flex;
                align-items: center;
            }
        }

        .author {
            display: flex;
            height: 100%;
            justify-content: center;

            padding: 10px 15px;

            .media {
                align-items: center;
            }
        }
    }

    @media screen and (min-width: 769px) {
        .author {
            .media {
                .title {
                    padding-top: 0;
                }
            }
        }
    }

</style>

<script>
    export default {
        props: {
            post: {
                type: Object,
                required: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/components/PostItem.vue